import { render } from "./LanguageSelect.vue?vue&type=template&id=e229b6e6&scoped=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"

import "./LanguageSelect.vue?vue&type=style&index=0&id=e229b6e6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e229b6e6"

export default script